import { values } from '@fortem-monorepo/js-utilities';
export const AUDIT_ELEMENT_TYPE = {
    Instrument: 'instrument',
    OldInstrument: 'old_instrument',
    Trade: 'trade',
    OldTrade: 'old_trade',
    IcGuideline: 'ic_guideline',
};
export const AUDIT_ELEMENT_TYPES = values(AUDIT_ELEMENT_TYPE);
export const APPROVAL_STATUS = {
    Approved: 'APPROVED',
    Draft: 'DRAFT',
    Pending: 'PENDING',
};
export const APPROVAL_STATUSES = values(APPROVAL_STATUS);
